import { Dashboard } from "../../types/dashboard";
import { generateAPI } from "../api.generator";

export const getDashboard = generateAPI<{}, Dashboard>("get", "dashboard");
